"use client";

import { useNativeAuth } from "@/hooks/useNativeAuth";

/**
 * Global deep link handler for Capacitor native apps.
 * Listens for env-specific URL scheme callbacks and handles:
 * - Auth callbacks (vidseeds-prod://auth-callback?code=XXX / vidseeds-stage://auth-callback?code=XXX)
 * - Platform callbacks (vidseeds-prod://oauth-callback?... / vidseeds-stage://oauth-callback?...)
 *
 * Renders nothing — pure side-effect component.
 */
export function NativeDeepLinkHandler() {
  useNativeAuth();
  return null;
}
